import React, { Component, PropsWithChildren } from 'react';
import { isUMUWebview, isWeixinBrowser } from '@umu/umu-ua';
import { classSet, openWindow } from '@umu/umu-dom';
import './navBar.scss';
import { SWITCH_STATUS, SendMsgType } from '@umu/umu-types';
import { isFromCourseMiniApp } from '../../@utils';
import umuWebview from '@umu/umu-webview';

interface IProps extends PropsWithChildren<{}> {
    defaultUrl?: string;
    title?: string | JSX.Element;
    isForceShow?: boolean;
    isForceCenterTitle?: boolean; // 是否强制标题居中，默认右边无元素时居中标题。
    isMultiple?: boolean; // 是否多行展示
    showShadow?: boolean;
    hideBack?: boolean;
    className?: string;
    onBack?(): void;
    allowAppSlideBack?: boolean; // 是否允许 app 侧滑返回，默认不允许，后续统一行为后修改为默认允许
    keepFullscreen?: boolean; // 是否保持全屏，默认不保持
    afterIcon?: JSX.Element;
}
export interface ISendMsgToWebData {
    type: SendMsgType;
    data?: {
        active?: string;
        actionType?: number;
        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
        info?: { [prop: string]: any };
    };
    [key: string]: unknown;
}
export default class NavBar extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.go = this.go.bind(this);
        this.dealMsgFromApp = this.dealMsgFromApp.bind(this);
    }
    public isBackSuccess = false;
    public onPopState = () => {
        this.isBackSuccess = true;
        // 可以在这里移除监听器，因为它不再需要了
        window.removeEventListener('popstate', this.onPopState);
    };
    public dealMsgFromApp(data: ISendMsgToWebData, callback: (data: any) => void) {
        if (data.type === SendMsgType.onAppBack) {
            const callbackParams = JSON.stringify({
                type: SendMsgType.onAppBack,
                data: {
                    keepFullscreen: this.props?.keepFullscreen ? SWITCH_STATUS.YES : SWITCH_STATUS.NO, // 全屏操作
                },
            });
            callback(callbackParams);
            this.go();
        }
    }
    // 渲染完成后判断是否在app 内在且允许 app 侧滑返回，如果允许则监听 app 侧滑返回事件
    public componentDidMount() {
        if (umuWebview.UA_INFO.isUMUWebview) {
            umuWebview.registerHandler('sendMsgToWeb', (data: ISendMsgToWebData, callback) => {
                this.dealMsgFromApp(data, callback);
            });
        }
    }

    public go() {
        const { defaultUrl, onBack } = this.props;
        if (defaultUrl) {
            openWindow(defaultUrl, '_self');
        } else if (onBack) {
            onBack();
        } else if (window.history.length > 1) {
            window.addEventListener('popstate', this.onPopState);

            history.back();
            // 延迟一些时间后检查后退是否成功
            setTimeout(() => {
                if (!this.isBackSuccess) {
                    openWindow('/', '_self');
                }
            }, 500);
        }
    }

    public renderPreIcon() {
        if (!this.props.hideBack && (window.history.length > 1 || this.props.defaultUrl || this.props.onBack)) {
            return (
                <button className="imitate-a back-btn" onClick={this.go}>
                    <i className="icon icon-arrow-black" />
                </button>
            );
        }
        return null;
    }

    public renderAfterIcon() {
        if (this.props.afterIcon) {
            return <div className="nav-bar-after-icon">{this.props.afterIcon}</div>;
        }
        return null;
    }

    public render() {
        const { className, isMultiple } = this.props;
        if (!this.props.isForceShow && (isWeixinBrowser || isUMUWebview) && !isFromCourseMiniApp()) {
            return null;
        } else {
            const containerCls = classSet({
                'nav-bar': true,
                'nav-shadow': !!this.props.showShadow,
            });
            const titleCls = classSet({
                'title': true,
                'nav-center-title': this.props.isForceCenterTitle || !this.props.children,
            });
            return (
                <div className={`${containerCls} ${className || ''} ${isMultiple ? 'multiple-lines' : 'one-line'}`}>
                    {this.renderPreIcon()}
                    <div className={titleCls}>{this.props.title}</div>
                    {this.renderAfterIcon()}
                    {this.props.children}
                </div>
            );
        }
    }
}
